import AssignmentRounded from "@mui/icons-material/WorkspacePremium";
import { Box, TableCell, TableRow, Typography } from "@mui/material";

export const NoJobsFound = () => (
  <TableRow>
    <TableCell sx={{ border: 0, pt: 8 }} colSpan={5}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", flex: 1 }}>
        <AssignmentRounded fontSize="extraLarge" />
        <Typography variant="h4" sx={{ mt: 1, textAlign: "center" }}>
          No assignments
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, textAlign: "center", pb: 8 }}>
          No goal templates have been assigned in bulk to athletes yet.
          <br />
          Get started by creating and assigning one today.
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
);
